import { createFileRoute } from '@tanstack/react-router';
import GroupsPage from 'src/Administration/GroupsPage/GroupsPage';

export const Route = createFileRoute('/systemadmin/_layout/groups/')({
  component: GroupsPage,
});
